export const getNameInitials = (name: string | undefined) => {
  if (name && name.indexOf(' ') > 0) {
    const nameParts = name.split(' ')
    return `${nameParts[0][0]}${nameParts[1][0]}`
  }
  return ''
}
